import { useNotifications } from "./NotificationsProvider.jsx";

/** Счётчик непрочитанного рядом с пунктом навигации. */
export function NotificationsCount() {
  const { unreadCount } = useNotifications();
  if (!unreadCount) return null;
  return (
    <span className="notifications-count">
      <span className="visually-hidden">Непрочитанных уведомлений: </span>
      {unreadCount > 9 ? "9+" : unreadCount}
    </span>
  );
}
